import React from "react";

import PersonaIniciativa from "./PersonaIniciativa";

const OrganizationList = ({ items }) => (
  items?.length
    ? <ul>{items.map((item) => <li key={item.id}>{item.nombre_completo || item.nombre}</li>)}</ul>
    : <span>-----</span>
);

const SeccionEquipo = ({ iniciativa }) => {
  if (!iniciativa) return <div>Cargando...</div>;

  return (
    <div className="actividad-info initiative-team-detail">
      <div className="initiative-section-heading initiative-tab-heading"><div><span>COORDINACIÓN</span><h5>Equipo y organizaciones</h5><p>Personas y entidades responsables de la iniciativa.</p></div></div>
      <h6 className="initiative-subsection-title">Equipo responsable</h6>
      {iniciativa.equipo?.length ? (
        <ul className="initiative-team-list">
          {iniciativa.equipo.map((item) => (
            <li key={item.id}>
              <PersonaIniciativa persona={item.profesional} detalle={item.rol} tone="profesional" />
            </li>
          ))}
        </ul>
      ) : <p className="initiative-empty-copy">No hay profesionales asignados.</p>}

      <div className="initiative-presenters">
        <h5>Relatoras</h5>
        {iniciativa.relatoras?.length ? (
          <ul>{iniciativa.relatoras.map((persona) => (
            <li key={persona.id}>
              <PersonaIniciativa persona={persona} detalle={persona.rut || "Sin RUT"} />
            </li>
          ))}</ul>
        ) : <p className="initiative-empty-copy">No hay relatoras asignadas.</p>}
      </div>

      <h5 className="initiative-subsection-title">Organizaciones</h5>
      <div className="initiative-organization-grid">
        <div><strong>Principales</strong><OrganizationList items={iniciativa.empresa} /></div>
        <div><strong>OTEC</strong><OrganizationList items={iniciativa.otec} /></div>
        <div><strong>Asociadas</strong><OrganizationList items={iniciativa.asociado} /></div>
      </div>
    </div>
  );
};

export default SeccionEquipo;
